import { CancelToken } from "axios";

import { IAPIError } from "shared/types";
import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem } from "shared/types";
import { IUserEmergencyContactPatchData } from "Bands/types";

interface IJSONAPIData {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIUserEmergencyContactCollection {
  [IDataKeys.userEmergencyContact]: IJSONAPIData;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class UserEmergencyContactService {
  static createUserEmergencyContact = (
    data: IUserEmergencyContactPatchData
  ): Promise<IJSONAPIUserEmergencyContactCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.post({
          path: API_ENDPOINTS.USER_EMERGENCY_CONTACTS,
          data,
        });
        resolve(response as IJSONAPIUserEmergencyContactCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_USER_EMERGENCY_CONTACT);
        reject({ error });
      }
    });

  static getUserEmergencyContacts = (
    queryParams?: string | { [key: string]: string | number | undefined | string[] },
    cancelToken?: CancelToken
  ): Promise<IJSONAPIUserEmergencyContactCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.get({
          path: API_ENDPOINTS.USER_EMERGENCY_CONTACTS,
          data: queryParams,
          cancelToken,
        });
        resolve(response as IJSONAPIUserEmergencyContactCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_USER_EMERGENCY_CONTACTS);
        reject({ error });
      }
    });

  static editUserEmergencyContact = (
    id: string,
    data: IUserEmergencyContactPatchData
  ): Promise<IJSONAPIUserEmergencyContactCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.patch({
          path: API_ENDPOINTS.USER_EMERGENCY_CONTACT(id),
          data,
        });
        resolve(response as IJSONAPIUserEmergencyContactCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_USER_EMERGENCY_CONTACT);
        reject({ error });
      }
    });

  static deleteUserEmergencyContact = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.USER_EMERGENCY_CONTACT(id),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_USER_EMERGENCY_CONTACT);
        reject({ error });
      }
    });
}
